import {Observable} from 'rxjs';

import {ListProductPayloadDto} from '@features/product/application/use_cases/list-product/dto/list-product.payload.dto';
import {ListProductResponseDto} from '@features/product/application/use_cases/list-product/dto/list-product.response.dto';

export abstract class ListProductUseCasePort {
  abstract execute(payload: ListProductPayloadDto): Observable<ListProductResponseDto>;
}
